var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Scheduled Closing Date"}},[_c('input-date',{attrs:{"name":"scheduled_closing_date","read_only":_vm.read_only,"input_id":"scheduled-closing-date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }